export const MODE = {
  YEAR: 0,
  MONTH: 1,
  DATE: 2,
  HOUR: 3,
  MINUTE: 4
}
